import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '../../../assets/languages/configs';
import IcNext from '../../../assets/imgs/ic_top.svg?react';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import TextCopy from '../../../components/TextCopy';
import Header from '../../../components/header/Header';
import { CHATBOT_URL } from '../../../utils/Constants';
import { convertTextToLinks, getValueByLanguage, isEmptyObject } from '../../../utils';

import styles from './styles.module.css';

/**
 * 図11-1 お問い合わせ画面
 */
const Contact = memo(() => {
    const { t } = useTranslation();
    const { user, isAuthenticated } = useFujiAuth();
    const { language } = i18n;

    const appConfig = JSON.parse(localStorage.getItem('APP_CONFIG') ?? '{}');
    const { contactAnnouncement } = appConfig;

    const l = useCallback((text: string) => getValueByLanguage(text, language), [language]);

    return (
        <div className={styles.contactContainer}>
            <Header title={t('my-profile.contact')} />
            <div className={`content-footer-container scrollable ${styles.contactContent}`}>
                {!isEmptyObject(contactAnnouncement) && (
                    <div className={styles.ticketContact}>
                        <div className={styles.title}>{t('contact.ticket-contact-title')}</div>
                        <p className={styles.contactTitle}>{convertTextToLinks(l(contactAnnouncement))}</p>
                    </div>
                )}
                <div className={styles.systemContact}>
                    <div className={styles.systemContactTitle}>
                        <div className={styles.title}>{t('contact.system-contact-label')}</div>
                        <div className={styles.contactTitle}>{t('contact.system-contact-title')}</div>
                    </div>
                    <div
                        className={styles.contactBtn}
                        onClick={() => {
                            window.open(CHATBOT_URL, '_blank', 'noopener,noreferrer');
                        }}
                    >
                        {t('contact.chatbot')}
                        <IcNext className={styles.icon} />
                    </div>
                    {isAuthenticated && (
                        <div className={styles.contactUserId}>
                            <span>{t('contact.user-id')}</span>
                            <TextCopy>{user && user.userId}</TextCopy>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default Contact;
